
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RunwayAttributes } from '../../../typings/features/runway-attributes';
import { AbstractDetailComponent } from '../abstract-detail.component';

@Component({
  selector: 'jmkw-runway-detail',
  standalone: true,
  imports: [],
  templateUrl: './runway-detail.component.html',
  styleUrls: ['./runway-detail.component.scss', '../nav-widgets.shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RunwayDetailComponent extends AbstractDetailComponent<RunwayAttributes> {
  @Input() attributes!: RunwayAttributes;
}
